import type { ListMediaAssetsParams, ListMediaPackagesParams } from '~/services/MediaService';

/** Everything svc-media caches hangs off this root, so one call can clear the lot. */
const MEDIA_ROOT = ['media'] as const;

export const mediaAssetQueryKeys = {
  all: [...MEDIA_ROOT, 'assets'] as const,
  lists: () => [...mediaAssetQueryKeys.all, 'list'] as const,
  list: (params: ListMediaAssetsParams) => [...mediaAssetQueryKeys.lists(), params] as const,
  details: () => [...mediaAssetQueryKeys.all, 'detail'] as const,
  detail: (assetId: string) => [...mediaAssetQueryKeys.details(), assetId] as const,
};

export const mediaPackageQueryKeys = {
  all: [...MEDIA_ROOT, 'packages'] as const,
  lists: () => [...mediaPackageQueryKeys.all, 'list'] as const,
  list: (params: ListMediaPackagesParams) => [...mediaPackageQueryKeys.lists(), params] as const,
  details: () => [...mediaPackageQueryKeys.all, 'detail'] as const,
  detail: (mediaPackageId: string) => [...mediaPackageQueryKeys.details(), mediaPackageId] as const,
};
